const API_URL = process.env.API_URL || 'https://territorioyacopini.com.ar/api/v2/shift';
//const API_URL = 'http://ywebsites.local:5000/api/v2/shift' || process.env.API_URL || 'https://territorioyacopini.com.ar/api/v2/shift';

export default API_URL;
